// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2LUJA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2DuO9"};